import React from 'react'
import { SectionCard } from './SectionCard'
import { VIDEO_LABELS, normalizeVideoMetrics, activeVideoKeys } from './videoMetrics'
import type { ContentTypeRow } from '../../../types/dashboard'

const ROW_COLORS = [
  'bg-blue-500', 'bg-emerald-500', 'bg-violet-500', 'bg-amber-500',
  'bg-rose-500', 'bg-cyan-500', 'bg-fuchsia-500', 'bg-lime-500',
]

interface Props {
  rows: ContentTypeRow[]
  sectionRef?: React.RefObject<HTMLDivElement>
}

export function ContentTypeSection({ rows, sectionRef }: Props) {
  const videoKeys = activeVideoKeys(rows.map(r => r.video_metrics))
  const totalCols = 6 + videoKeys.length

  return (
    <SectionCard title="Content Types" sectionRef={sectionRef} id="section-content-types">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 dark:border-gray-700">
              <th className="text-left py-2 pr-4 text-gray-500 dark:text-gray-400 font-medium">Content Type</th>
              <th className="text-right py-2 pr-4 text-gray-500 dark:text-gray-400 font-medium">CTR %</th>
              <th className="text-right py-2 pr-4 text-gray-500 dark:text-gray-400 font-medium">Impressions</th>
              <th className="text-right py-2 pr-4 text-gray-500 dark:text-gray-400 font-medium">Clicks</th>
              <th className="text-right py-2 pr-4 text-gray-500 dark:text-gray-400 font-medium">Engagement</th>
              {videoKeys.map(k => (
                <th key={k} className="text-right py-2 pr-4 text-gray-500 dark:text-gray-400 font-medium">{VIDEO_LABELS[k]}</th>
              ))}
              <th className="py-2 text-gray-500 dark:text-gray-400 font-medium"></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => {
              const norm = normalizeVideoMetrics(row.video_metrics)
              return (
                <tr key={i} className="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800/40">
                  <td className="py-3 pr-4 font-medium text-gray-900 dark:text-white">{row.content_type}</td>
                  <td className="py-3 pr-4 text-right text-gray-800 dark:text-gray-200">{row.ctr.toFixed(2)}%</td>
                  <td className="py-3 pr-4 text-right text-gray-800 dark:text-gray-200">{row.impressions.toLocaleString()}</td>
                  <td className="py-3 pr-4 text-right text-gray-800 dark:text-gray-200">{row.clicks.toLocaleString()}</td>
                  <td className="py-3 pr-4 text-right text-gray-800 dark:text-gray-200">{row.engagement.toLocaleString()}</td>
                  {videoKeys.map(k => {
                    const m = norm[k]
                    return (
                      <td key={k} className="py-3 pr-4 text-right text-gray-800 dark:text-gray-200">
                        {m && m.count > 0 ? `${m.count.toLocaleString()} (${m.pct.toFixed(2)}%)` : '—'}
                      </td>
                    )
                  })}
                  <td className="py-3">
                    <span className={`inline-block w-3 h-3 rounded-full ${ROW_COLORS[i % ROW_COLORS.length]}`} />
                  </td>
                </tr>
              )
            })}
            {rows.length === 0 && (
              <tr>
                <td colSpan={totalCols} className="py-8 text-center text-gray-400">No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </SectionCard>
  )
}
